/**
 * Where each system info page's "Apply" button goes - straight to the application form, so
 * there are no unnecessary clicks between reading about a permit and applying for it.
 *
 * Keyed by the page's systemKey (from the backend), not its slug, so the URL TLC give a
 * page can change without breaking the wiring. Fishing and Hunting carry two buttons each
 * (14-day / Annual); everything else carries one.
 */
export interface ApplyTarget {
    label: string;
    route: string;
    /** Optional query params, e.g. the fishing/hunting term or recreation access type. */
    query?: { [key: string]: string };
}

export const INFO_PAGE_APPLY: { [systemKey: string]: ApplyTarget[] } = {
    tourism: [{ label: 'Apply for a Tourist Permit', route: '/apply/tourist-pass' }],
    work: [{ label: 'Apply for a Work Permit', route: '/apply/work' }],
    media: [{ label: 'Apply for a Media Permit', route: '/apply/media' }],
    research: [{ label: 'Apply for a Research Permit', route: '/apply/research' }],
    friends_family: [{ label: 'Apply for a Friends & Family Permit', route: '/apply/friends-family' }],
    recreation_area: [{ label: 'Apply for a Recreation Permit', route: '/apply/recreation' }],
    // The recreation form already scopes to boat-access sites on ?sites=boat.
    boat_access: [{ label: 'Apply for a Boat-access Recreation Permit', route: '/apply/recreation', query: { sites: 'boat' } }],
    // The fishing/hunting form reads ?holder: host = a 14-day visitor quoting a host permit,
    // self = an annual resident quoting their own work/LTR permit.
    fishing: [
        { label: 'Apply for a 14-day Fishing Permit', route: '/apply/fishing', query: { holder: 'host' } },
        { label: 'Apply for an Annual Fishing Permit', route: '/apply/fishing', query: { holder: 'self' } },
    ],
    hunting: [
        { label: 'Apply for a 14-day Hunting Permit', route: '/apply/hunting', query: { holder: 'host' } },
        { label: 'Apply for an Annual Hunting Permit', route: '/apply/hunting', query: { holder: 'self' } },
    ],
    business_login: [{ label: 'Apply for a Business Login', route: '/apply/business-login' }],
};
